import { isInternalAiNote, type CVEditingSection, type FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface ComplementaryInfoProps {
  hasRQTH: FullCV['hasRQTH'];
  complementaryMentions: FullCV['complementaryMentions'];
  accent: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function ComplementaryInfo({
  hasRQTH,
  complementaryMentions,
  accent,
  onEdit,
}: ComplementaryInfoProps) {
  const { t } = useCVTranslation();
  const handleEdit = () => onEdit && onEdit('complementaryInfo');
  const editable = onEdit !== undefined;

  if (!hasRQTH && !complementaryMentions?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable} accentColor={accent}>
      <div className="rounded-lg border p-2.5">
        <h2 className="text-[11px] font-black uppercase tracking-widest text-black">
          {t('CV.complementaryInfo')}
        </h2>
        <ul className="mt-1 space-y-1">
          {hasRQTH && <li className="text-[13px] font-semibold">• {t('CV.hasRQTH')}</li>}
          {(complementaryMentions ?? [])
            .filter(mention => mention.toUpperCase() !== 'RQTH' && !isInternalAiNote(mention))
            .map((mention, i) => (
              <li key={i} className="text-[13px] font-semibold">
                • {mention}
              </li>
            ))}
        </ul>
      </div>
    </EditableSection>
  );
}
